import { getFontSizeInPx } from "src/utils"

// variables defined in src/styles/home.scss
export function getExpectedGraphHeight(): number {
  const heightInRem = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--graph-height"))
  const fontSize = getFontSizeInPx()

  if (isNaN(heightInRem) || isNaN(fontSize)) {
    return 240
  }

  return heightInRem * fontSize
}
